<app-header></app-header>
<div class="flex-row body-wrapper">
  <div class="flex-8">
    <div class="form-wrapper">
      <!-- <router-outlet *ngIf="(auth.loggedIn || auth.loggingIn); else noAcces"></router-outlet> -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

